import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import IconArrow from '~/assets/images/select-arrow.svg'
import IconQuestionMark from '~/assets/images/question-mark-gray.svg'
import FullPageModal from '~/components/FullPageModal'
import Tooltip from '~/components/Tooltip'
import { updateLimitOrderUserConfig } from '~/state/dex/actions'
import { useLimitOrderUserConfig } from '~/state/dex/hooks'
import { LimitOrderExpiration } from '~/state/dex/type'
import { useAppDispatch } from '~/state/hooks'
import {
  ModalContentWrapper,
  ModalTitle,
  InputLabel,
  InputWrapper,
  Option,
  Options,
} from './styled'
import { lockBody } from '~/utils/lockBody'
import { useGA } from '~/hooks'

const MIN = 60 * 1000 // 60 milliseconds
const HOUR = 60 * MIN
const DAY = 24 * HOUR

const DateSelect: React.FC = () => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)
  const { expiration } = useLimitOrderUserConfig()
  const {
    Min5,
    Min20,
    Hour1,
    Hour12,
    Day1,
    Day3,
    Day7,
    Week2,
    Month6,
  } = LimitOrderExpiration

  const options = [Min5, Min20, Hour1, Hour12, Day1, Day3, Day7, Week2, Month6]
  const [value, unit] = expiration.split('_')
  const dispatch = useAppDispatch()
  const { trackClick } = useGA()

  const onExpiredTimeSelect = (item: LimitOrderExpiration) => {
    trackClick('webtl_lo_expire_confirm', { type: item })
    dispatch(updateLimitOrderUserConfig({ expiration: item }))
    setIsOpen(false)
  }

  useEffect(() => {
    lockBody(isOpen)
  }, [isOpen])

  return (
    <>
      <div>
        <InputLabel>{t('expired_time')}</InputLabel>
        <Tooltip
          placement="right"
          title={t('expired_time_note')}
          trigger="hover"
          img={IconQuestionMark}
        />
        <InputWrapper onClick={() => setIsOpen(true)}>
          {value} {t(unit)}
          <img src={IconArrow} />
        </InputWrapper>
      </div>
      <FullPageModal onClose={() => setIsOpen(false)} visible={isOpen}>
        <ModalContentWrapper>
          <ModalTitle>{t('expired_time_setting')}</ModalTitle>
          <Options>
            {options.map((item) => {
              const [value, unit] = item.split('_')
              return (
                <Option
                  active={item === expiration}
                  key={value + unit}
                  onClick={() => onExpiredTimeSelect(item)}
                >
                  {value + ' ' + t(unit)}
                </Option>
              )
            })}
          </Options>
        </ModalContentWrapper>
      </FullPageModal>
    </>
  )
}

export default DateSelect
